import DefaultDetail from "@Common/DefaultDetail";
import { useParams } from "react-router-dom";

const ReplaceDataDetail = () => {
    const { secondParam } = useParams();

    let inputs = [
        {
            blockName: "Конфиг для аб теста",
            inputs: {
                title: { label: "Название", type: "string", required: true },
                active: { label: "Активность", type: "checkbox", required: false },
                siteId: {
                    label: "Сайт на котором используется",
                    type: "selectSuggest",
                    required: true,
                    filterBy: "name, _id",
                    apiUrl: "/promo/suggest_list?collection=sites&project[_id]=1&project[code]=1&project[name]=1&project[archived]=1&sortField=name&sortOrder=asc",
                    dataKey: "suggest.sites_suggest",
                    optionValue: "_id",
                    optionLabel: "name",
                    placeholder: "Выберите сайт",
                    // appendTo: 'self',
                    // filterFunction: ({ options, currentValue }) => {
                    //     if (options && options.length > 0) {
                    //         return options.filter((it) => !it.archived);
                    //     }
                    //     return options;
                    // },
                },
                offerId: {
                    label: "Оффер",
                    type: "selectSuggest",
                    filterBy: "title,_id",
                    required: true,
                    apiUrl: "/promo/suggest_list?collection=offers&project[_id]=1&project[technicalName]=1&project[code]=1&project[title]=1&project[availableOn]=1&project[siteId]=1&sortField=name&sortOrder=asc",
                    dataKey: "suggest.offers_suggest",
                    optionValue: "_id",
                    optionLabel: "title",
                    placeholder: "Выберите оффер",
                    copied: true,
                    // filterFunction: ({ options, currentValue }) => {
                    //     if (currentValue.siteId && options && options.length > 0) {
                    //         return options.filter((it) => it?.availableOn?.includes(currentValue.siteId));
                    //     }
                    //     return options;
                    // },
                },
            },
        },
        {
            blockName: "Что заменяем",
            inputs: {
                replacesData: {
                    label: "Что будем заменять",
                    type: "objectInputs",
                    required: false,
                    inputs: {
                        sortNum: { label: "Сортировка", type: "number", required: false },
                    },
                },
            },
        },
    ];

    return (
        <DefaultDetail
            apiUrl={secondParam === "add" ? "/abtest/offerreplaces" : `/abtest/offerreplaces/${secondParam}`}
            dataKey={secondParam}
            inputs={inputs}
            titleList={"title"}
            urlUpload={"offers"}
            logging={true}
            title={"Замена для офферов"}
            titleRight={"замену"}
            scopes={false}
            page={"offerreplaces"}
        />
    );
};

export default ReplaceDataDetail;
